<template>
  <div class="log-despesa">
    <div class="log-busca">
      <div class="icon-adjustment">
        <input placeholder="Pesquisar log" class="form-control input-paddi w-100 h-100" v-model="busca">
        <i aria-hidden="true" class="fas fa-search icon-search"></i>
      </div>
    </div>

    <div class="log-trilha mt-3">
      <div v-for="(data, index) in logFiltrado" :key="data.logId">
        <div class="d-flex flex-row mt-1 ml-2">
          <div class="linhaAling">
            <div class="ballCrzy">
              <div class="textNum">{{ data.diaFormatada }}</div>
              <div class="textNum">{{ mostrarNomeMes(data.mesFormatada) }}</div>
            </div>
            <div class="linhaSolid"></div>
          </div>
          <div class="ml-3 mt-3">
            <div class="squareCrzy">
              <div class="Textneg">
                {{ data.titulo }}
                <!-- o writer grava a mesma movimentacao N vezes num burst de milissegundos; o
                     servidor colapsa e devolve a contagem. Mostrar o x6 e o que impede o colapso
                     de virar mentira. -->
                <span v-if="data.derivado" class="log-derivado"
                  title="Esta aprovação aconteceu, mas não foi gravada no log: a linha foi reconstruída pela data da etapa registrada na própria despesa. Por isso não há autor.">reconstruído</span>
                <span v-if="data.repeticoes > 1" class="log-repeticoes"
                  :title="'A tabela tem ' + data.repeticoes + ' linhas idênticas para esta movimentação'">{{ data.repeticoes }}×</span>
              </div>
              <div class="Textneg2">
                <div class="description-log">
                  <i class="fas fa-user-circle" style="scale: 1.25"></i>
                  <!-- linha reconstruida pelo carimbo de etapa nao tem quem fez; dizer 'N/D' aqui
                       esconderia que a informacao nao existe, e nao que a pessoa e desconhecida -->
                  <span v-if="data.derivado" class="log-sem-autor">sem registro de autor</span>
                  <span v-else>{{ data.nomeConta ? data.nomeConta : 'N/D' }}</span>
                </div>
                <div class="description-log">
                  <i class="far fa-clock" style="scale: 1.25"></i>{{ data.dataFormatada }}
                </div>
                <!-- a trilha do funcionario e por MOVIMENTO: um cartao pode carregar N despesas que
                     andaram juntas. Sem este numero o cartao mentiria, parecendo uma despesa. -->
                <div class="description-log log-origem" v-if="mostraOrigem && data.despesas > 1">
                  <i class="fas fa-layer-group" style="scale: 1.25"></i>
                  <span>{{ data.despesas }} despesas</span>
                </div>
                <div class="description-log log-origem" v-else-if="mostraOrigem && data.despesaDataFormatada">
                  <i class="fas fa-receipt" style="scale: 1.25"></i>
                  <span>{{ data.despesaDataFormatada }} · {{ data.despesaCategoria || 'N/D' }} · {{ formatarValor(data.despesaValor) }}</span>
                </div>
                <div class="description-log" v-if="data.motivoRecusa">
                  <i class="far fa-comment-alt" style="scale: 1.25"></i>
                  <span class="log-motivo" :title="data.motivoRecusa">{{ data.motivoRecusa }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="index === logFiltrado.length - 1" class="d-flex flex-row mt-1 ml-2">
          <div class="linhaAling">
            <div class="ballCrzy">
              <div class="fas fa-check ballCrzyDone"></div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="carregou && logFiltrado.length < 1" class="d-flex flex-row mt-1 ml-2">
        <div class="d-flex align-items-center w-100 flex-row mt-1">
          <div class="linhaAling mr-3">
            <div class="ballCrzy">
              <div class="fas fa-question ballCrzyDone"></div>
            </div>
          </div>
          <div class="Textneg">{{ busca ? 'Nenhum log casa com a busca!' : 'Nenhum registro de log foi encontrado!' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LogDespesa from './LogDespesa'
export default LogDespesa
</script>

<style scoped>
/* ZC-44: mesma linguagem visual do Log de Status do Reembolso de Viagem (FormDetailsAdvance.vue),
   com duas diferencas deliberadas: o cartao usa min-height em vez de height fixo, porque a frase
   daqui ("foi do status X e atualizada para status Y") mais o motivo da devolucao estouram os
   150px do original; e a largura e fluida com teto, para caber na coluna da tela de Diversos. */
.log-despesa {
  font-family: 'Segoe UI';
}

.log-busca .icon-adjustment {
  display: flex;
  flex-direction: row-reverse;
  align-items: baseline;
  border: 1px solid #ced4da;
  padding-left: 5px;
  width: 320px;
  max-width: 100%;
}

.log-busca .form-control {
  border: 1px none;
  border-radius: 0;
  padding-left: 5px;
  font-size: 0.875rem;
  height: calc(1.5em + 0.75rem + 2px);
}

.ballCrzy {
  width: 50px;
  height: 50px;
  min-width: 50px;
  border-radius: 50%;
  border: 3px solid;
  font-size: 16px;
}

.ballCrzyDone {
  display: flex;
  justify-content: center;
  padding-top: 13px;
  font-size: 20px;
}

.linhaAling {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  color: #008148;
}

.linhaSolid {
  flex: 1 1 auto;
  min-height: 40px;
  border-left: 2px solid;
}

.textNum {
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
}

.squareCrzy {
  width: 100%;
  max-width: 620px;
  min-height: 110px;
  background: rgb(243, 241, 241);
  border-radius: 1px 15px 15px;
  color: #111;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem 1rem 1rem 2rem;
  box-shadow: 10px 10px 5px 0px #d2d2d2;
  justify-content: space-between;
}

.Textneg {
  font-weight: bold;
  font-size: 17px;
  color: #008148;
}

.Textneg2 {
  font-size: 12px;
  color: rgb(116, 121, 116);
  font-weight: bold;
  display: flex;
  flex-direction: column;
}

.description-log {
  display: flex;
  gap: 1rem;
  align-items: center;
}

/* a despesa de origem so aparece na trilha do funcionario, onde varias se intercalam por data */
.log-origem {
  color: #495057;
}

.log-derivado {
  font-size: 11px;
  font-weight: bold;
  color: #8a6d3b;
  background: #fcf3d7;
  border: 1px solid #f0dca4;
  border-radius: 10px;
  padding: 1px 7px;
  margin-left: 6px;
  vertical-align: middle;
}

.log-sem-autor {
  font-weight: normal;
  font-style: italic;
}

.log-repeticoes {
  font-size: 11px;
  font-weight: bold;
  color: #6c757d;
  background: #e9ecef;
  border-radius: 10px;
  padding: 1px 7px;
  margin-left: 6px;
  vertical-align: middle;
}

.log-motivo {
  font-weight: normal;
  white-space: normal;
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/views/private/miscellaneousreimbursement/components/LogDespesa/LogDespesa.vue